import React from 'react'
import { thousandsSeparator } from 'utils'

import Box from '@mui/material/Box'

interface Props {
  value: number | null
}

function ComparedValue({ value }: Props) {
  return (
    <Box color="#989898" display="inline">
      {' | '}
      {thousandsSeparator(value)}
    </Box>
  )
}

export default ComparedValue
